import AIEduDataTable from '../../components/DataTable/AIEduDataTable';
import styles from './ActivityLogs.module.css';
import {
    convertSecondsToTimeStamp,
    formatDateWithTimeStamp,
} from '../../utils/Utils';

const LiveTranscript = ({
    f,
    data,
    sortField,
    sortOrder,
    onSort,
    sortIcon,
    dataKey,
}) => {
    const timeStampTemplate = (rowData) => {
        return !!rowData.createdTime
            ? formatDateWithTimeStamp(rowData.createdTime)
            : '--';
    };

    const sessionDurationTemplate = (rowData) => {
        return !!rowData.duration
            ? convertSecondsToTimeStamp(rowData.duration)
            : '00:00:00';
    };

    const emailTemplate = (rowData) => {
        return (
            <div
                className={styles.user_email_template}
                title={rowData.userEmail}
            >
                {rowData.userEmail}
            </div>
        );
    };

    const columns = [
        {
            field: 'userEmail',
            header: f({ id: 'AI_EDU_USER_EMAIL' }),
            body: emailTemplate,
            sortable: true,
            width: '35%',
            minWidth: '20rem',
        },
        {
            field: 'userName',
            header: f({ id: 'AI_EDU_USER_NAME' }),
            sortable: true,
            width: '20%',
            minWidth: '15rem',
        },
        {
            field: 'screenId',
            header: f({ id: 'AI_EDU_DEVICE_MAC' }),
            sortable: true,
            width: '15%',
            minWidth: '10rem',
        },
        {
            field: 'createdTime',
            header: f({ id: 'AI_EDU_TIME_STAMP' }),
            body: timeStampTemplate,
            sortable: true,
            width: '15%',
            minWidth: '10rem',
        },
        {
            field: 'duration',
            header: f({ id: 'AI_EDU_SESSION_DURATION' }),
            body: sessionDurationTemplate,
            sortable: true,
            minWidth: '10rem',
        },
    ];
    return (
        <AIEduDataTable
            key={dataKey}
            data={data}
            columns={columns}
            sortField={sortField}
            sortOrder={sortOrder}
            sortIcon={sortIcon}
            onSort={onSort}
            lazy={true}
            scrollHeight='60vh'
            emptyMessage={f({ id: 'AI_EDU_NO_DATA_TO_SHOW' })}
        />
    );
};

export default LiveTranscript;
